import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";

// Shared modal shell for full-screen game views (Stats / Achievements / Donations).
// Provides backdrop, entrance animation, close button, and a scrollable body.
export const ViewModal = ({ open, onClose, title, subtitle, children, testId }) => {
  return (
    <AnimatePresence>
      {open && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2 }}
          className="fixed inset-0 z-40 flex items-start justify-center px-4 py-6 sm:py-10"
          style={{ backgroundColor: "rgba(0,0,0,0.8)" }}
          onClick={onClose}
          data-testid={`${testId}-backdrop`}
        >
          <motion.div
            initial={{ opacity: 0, y: 30, scale: 0.98 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 30, scale: 0.98 }}
            transition={{ duration: 0.24 }}
            className="relative w-full max-w-3xl max-h-[85vh] flex flex-col"
            style={{
              backgroundColor: "#0d0d0d",
              border: "1px solid #FFD400",
              borderRadius: 4,
            }}
            onClick={(e) => e.stopPropagation()}
            data-testid={testId}
          >
            <header className="flex items-center justify-between px-6 py-4 border-b" style={{ borderColor: "#1c1c1c" }}>
              <div>
                <h2
                  className="text-lg sm:text-xl font-black uppercase tracking-[0.3em]"
                  style={{ color: "#FFD400", fontFamily: "Orbitron, sans-serif" }}
                >
                  {title}
                </h2>
                {subtitle && (
                  <p className="text-[10px] uppercase tracking-[0.3em] text-white/50 mt-1">
                    {subtitle}
                  </p>
                )}
              </div>
              <button
                type="button"
                onClick={onClose}
                aria-label="Close"
                data-testid={`${testId}-close`}
                className="text-white/60 hover:text-white p-1"
              >
                <X size={18} />
              </button>
            </header>
            <div className="flex-1 overflow-y-auto p-6">{children}</div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default ViewModal;
